const templateUrl = require('./frequency.html');
const ctrl = require('./frequency-control.controller');

module.exports = angular.module('msi.frequency.control', [
  ctrl.module
]).name;

angular.module(module.exports)
  .component('ogFrequencyControl', {
    bindings: {
      subscription: '=ogFor',
      publicId: '<'
    },
    controller: ctrl.name,
    templateUrl: templateUrl
  });
